module.exports = __webpack_public_path__ + "static/siddhartha-6d9a2848ecaa450a86c4dfea81e65458.jpg";